// Production-safe defaults. If an env var is not set the value falls back to
// the live CDN so we never end up with `undefined + "/some/path"` (which
// renders as the literal string "undefined/some/path" in image src attributes
// and causes 404s like /img and /undefined* in the network panel).
export const host =
  process.env.NEXT_PUBLIC_API_SERVER_PATH || "https://backend.clamphook.com";
export const staticImgUrl =
  process.env.NEXT_PUBLIC_STATIC_IMG_BASE_URL ||
  "https://assets.clamphook.com/clamphook-static/";
export const staticVideoUrl =
  process.env.NEXT_PUBLIC_STATIC_VIDEO_BASE_URL ||
  "https://assets.clamphook.com/clamphook-static/";
export const imgUrl =
  process.env.NEXT_PUBLIC_IMG_BASE_URL ||
  "https://assets.clamphook.com/clamphook-dynamic/";

/** Safe replacement for `imgUrl + path`. Returns the path unchanged when it is
 *  already an absolute URL, preventing the double-prefix bug. */
export const resolveImgUrl = (path?: string | null): string => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const p = path.startsWith("/") ? path.slice(1) : path;
  return imgUrl + p;
};

export const formatNpr = (amount: number) =>
  `NPR ${new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  }).format(amount)}`;
export const videoUrl =
  process.env.NEXT_PUBLIC_VIDEO_BASE_URL ||
  "https://assets.clamphook.com/clamphook-dynamic/";
export const khaltiTestLiveSecretKey =
  process.env.NEXT_PUBLIC_KHALTI_TEST_LIVE_SECRET_KEY || "";
//export const frontendHost = process.env.NEXT_PUBLIC_HOST_PATH;

/** The dedicated IOE Entrance exam-taking site (separate deployment of the
 *  same codebase, ioe-entrance-ui repo) -- students already logged in here
 *  can jump straight into it via /session-entry, which hands off the
 *  current access/refresh token instead of making them log in again. */
export const runAppUrl =
  process.env.NEXT_PUBLIC_RUN_APP_URL || "https://run.clamphook.com";

//refresh token end point utl
export const apiEndpoints = {
  refresh: `${host ? host : "https://clamphook.com"}/auth/refresh`,
};
